// Dependency-neutral active-organization persistence.
//
// API modules must not import OrgContext: OrgContext loads organizations.ts,
// which loads api/client.ts. Keeping storage access here lets the shared HTTP
// client read the current selection at request time without forming a cycle.

export const ACTIVE_ORG_STORAGE_KEY = "active_org_id_v2";

export function getActiveOrgId(): string | null {
  try {
    return window.localStorage.getItem(ACTIVE_ORG_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setActiveOrgId(orgId: string): void {
  try {
    window.localStorage.setItem(ACTIVE_ORG_STORAGE_KEY, orgId);
  } catch {
    // localStorage unavailable (private mode) — session-only.
  }
}

export function removeActiveOrgId(): void {
  try {
    window.localStorage.removeItem(ACTIVE_ORG_STORAGE_KEY);
  } catch {
    // best-effort
  }
}
